module.exports = __webpack_public_path__ + "static/media/Export_Icon.770f6541.svg";